<template>
<div class="content content--onepane">
  <form class="form editor">
    <div class="form-side">
      <div class="form-row">
        <input class="form-text" type="text" v-model="formData.symbol">
        <a :href="setUrl" target="_blank">
          <i class="i form-infoLink">link</i>
        </a>
      </div>
      <div class="form-row">
        <input class="form-text" type="text" v-model="formData.name">
      </div>
      <div class="form-row">
        <input class="form-text" type="text" v-model="formData.industry">
        <input class="form-text" type="text" v-model="formData.sector">
      </div>
      <button class="button" @click.prevent="saveStock">
        <i class="i">check</i>
        Save
      </button>
    </div>
    <div class="form-belly">
      <tabs>
        <tab name="Info">
          <div class="form-row">
            <input class="form-text" type="text" v-model="formData.symbol">
          </div>
          <div class="form-row">
            <input class="form-text" type="text" v-model="formData.name">
          </div>
          <div class="form-row">
            <input class="form-text" type="text" v-model="formData.industry">
            <input class="form-text" type="text" v-model="formData.sector">
          </div>
        </tab>

        <tab name="Notes" selected>
          <longform-editor v-model="formData.note" placeholder="Notes">
          </longform-editor>
        </tab>

        <tab name="Financial">
          <longform-editor v-model="formData.financial" placeholder="Financial">
          </longform-editor>
        </tab>

        <tab name="SWOT">
          <textarea class="form-textarea" v-model="formData.swot.s"></textarea>
          <textarea class="form-textarea" v-model="formData.swot.w"></textarea>
          <textarea class="form-textarea" v-model="formData.swot.o"></textarea>
          <textarea class="form-textarea" v-model="formData.swot.t"></textarea>
        </tab>
      </tabs>
    </div>
    <div class="form-foot">
      <button class="button" @click.prevent="saveStock">
        <i class="i">check</i>
        Save
      </button>
    </div>
  </form>
</div>
</template>

<script>
import firebase from 'firebase';
import * as Firebase from '../config.js';

import Stock from '../helpers/Stock';
import marked from 'marked';

export default {
  data(){ return{
    editMode: false,

    formData: {
      symbol: '',
      name: '',
      industry: '',
      sector: '',
      note: '',
      financial: '',
      swot: {
        s: '',
        w: '',
        o: '',
        t: ''
      },
      updated: ''
    }
  }},

  computed: {
    setUrl(){
      return 'https://www.set.or.th/set/companyprofile.do?symbol='
        + this.formData.symbol;
    }
  },

  firebase: {
    stocks: Firebase.stocks
  },

  methods: {
    saveStock(){
      //validate, make this into its own class later
      let valid = true;
      let errors = [];

      if(this.formData.symbol === ''){
        valid = false;
        errors.push('Empty symbol');
      }

      if(this.formData.name === ''){
        valid = false;
        errors.push('Empty name');
      }

      if(this.formData.industry === ''){
        valid = false;
        errors.push('Empty industry');
      }

      //sanitise
      this.formData.symbol = this.formData.symbol.toUpperCase();
      this.formData.updated = (new Date).toISOString();

      if(this.formData.starred === undefined){
        this.formData.starred = false;
      }

      //check if symbol already exists

      if(valid){
        Firebase.stocks.child(this.formData.symbol).set(this.formData);
        this.$router.push('/stock/' + this.formData.symbol);
      }
    }
  },

  mounted(){
    if(this.$route.params.symbol){
      //is in edit mode
      this.editMode = true;
      Stock.get(this.$route.params.symbol).then(snapshot => {
        this.formData = snapshot.val();
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// newstock.vue?0347f8a0